var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card__content" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-xs-12" },
              [
                _c("k-table", {
                  ref: "listaStowage",
                  attrs: {
                    exportable: _vm.exportable,
                    mostrarTodos: false,
                    columns: _vm.columns,
                    path: _vm.path,
                    deleteButton: _vm.deleteButton && _vm.permiteEliminar,
                    createButton: _vm.permiteCrear,
                    filterStatus: false,
                    editButton: _vm.editButton && _vm.permiteEditar
                  },
                  on: {
                    editar: _vm.editar,
                    eliminar: _vm.eliminar,
                    crear: _vm.crear
                  }
                })
              ],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            clickToClose: false,
            name: "stowage",
            width: "60%",
            height: "auto",
            scrollable: ""
          }
        },
        [
          _c("stowage", {
            attrs: { customers: _vm.customers },
            on: { saved: _vm.saved, cancelar: _vm.cancelar },
            model: {
              value: _vm.selectedItem,
              callback: function($$v) {
                _vm.selectedItem = $$v
              },
              expression: "selectedItem"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h3", [_vm._v("Consulta de Stowage")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ec6f387a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec6f387a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/stowage/ListaStowage.vue
// module id = 400
// module chunks = 0